// for communication with our browser extension
import debounce from "lodash/debounce"
import { GQL } from "platform-common/index"
import { getWindow } from "@web/utils"

export enum AuthenticateStateChangeType {
  SignedOut = "SignedOut",
  NewSession = "NewSession",
  NewAuthChallengeToken = "NewAuthChallengeToken",
  UpdateSequencerAuthStatus = "UpdateSequencerAuthStatus",
  UpdateAtsIntegrationStatus = "UpdateAtsIntegrationStatus",
}

// the messages the web app recognizes
// subset of common BrowserMessageType
export enum BrowserMessageType {
  UpdateSequencerAuthStatus = "UpdateSequencerAuthStatus",
  UpdateAtsIntegrationStatus = "UpdateAtsIntegrationStatus",
  PlatformSignOut = "PlatformSignOut",
  ExtensionSignOut = "ExtensionSignOut",
  GetExtensionStatus = "GetExtensionStatus",
  GotExtensionStatus = "GotExtensionStatus",
  AuthenticateWithToken = "AuthenticateWithToken",
  GetExtensionEnabledUrls = "GetExtensionEnabledUrls",
  SetExtensionEnabledUrls = "SetExtensionEnabledUrls",
}

interface NotifyAuthenticationStateChangedArgs {
  type: AuthenticateStateChangeType
}

interface NotifyLogoutArgs extends NotifyAuthenticationStateChangedArgs {
  type: AuthenticateStateChangeType.SignedOut
}

interface NotifySequencerAuthStateChangedArgs extends NotifyAuthenticationStateChangedArgs {
  sequencerAuth?: GQL.SequencerAuthStatusFragmentFragment
  type: AuthenticateStateChangeType.UpdateSequencerAuthStatus
  isAutoConnect: boolean
}

interface NotifyAtsIntegrationStateChangedArgs extends NotifyAuthenticationStateChangedArgs {
  atsIntegrationStatus?: GQL.AtsIntegrationStatusFragmentFragment
  type: AuthenticateStateChangeType.UpdateAtsIntegrationStatus
  isAutoConnect: boolean
}

export const notifyAuthenticationStateChanged = debounce(
  async (args: NotifyLogoutArgs | NotifySequencerAuthStateChangedArgs | NotifyAtsIntegrationStateChangedArgs) => {
    console.debug("Auth state changed, type:", args.type)

    switch (args.type) {
      // sync logout -> extension
      case AuthenticateStateChangeType.SignedOut:
        getWindow()?.postMessage({
          message: BrowserMessageType.PlatformSignOut,
        })
        break

      case AuthenticateStateChangeType.UpdateSequencerAuthStatus:
        // sequencer auth changed
        getWindow()?.postMessage({
          message: BrowserMessageType.UpdateSequencerAuthStatus,
          isAutoConnect: args.isAutoConnect,
          sequencerAuth: args.sequencerAuth,
        })
        break

      case AuthenticateStateChangeType.UpdateAtsIntegrationStatus:
        // ATS integration status changed
        getWindow()?.postMessage({
          message: BrowserMessageType.UpdateAtsIntegrationStatus,
          isAutoConnect: args.isAutoConnect,
          atsIntegrationStatus: args.atsIntegrationStatus,
        })
        break
    }
  },
  500,
  { leading: true }
)
